import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'semantic-ui-css/semantic.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import injectTapEventPlugin from 'react-tap-event-plugin';
import 'mousetrap-global-bind';
import { Provider } from 'react-redux';
import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import store from './store/store';
import apiBaseUrl from './utils/apiBaseUrl';
import { logout } from './utils/logout';
import { setGraphQLErrors, setNetworkError } from './utils/errorHandler';
import { from, ApolloLink } from 'apollo-link';

const authLink = setContext((_, { headers }) => {
  const token =
    localStorage.getItem('redux') &&
    JSON.parse(localStorage.getItem('redux')).authorization.authToken;
  return {
    headers: {
      ...headers,
      Authorization: token ? ` Token token=${token}` : null,
    },
  };
});

const logoutLink = onError(({ networkError }) => {
  if (networkError && networkError.statusCode === 401) logout();
});

const errorsLink = onError(({ operation, graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    setGraphQLErrors(graphQLErrors, operation);
  }
  if (networkError) {
    setNetworkError(networkError, operation);
  }
});

const httpLink = new HttpLink({ uri: apiBaseUrl + '/crm/graphql' });

const defaultOptions = {
  watchQuery: {
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
  },
  query: {
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
  },
  mutate: {
    errorPolicy: 'all',
  },
};

const readonlyMiddleware = new ApolloLink((operation, forward) => {
  // Check if the operation is a mutation and role is read-only
  if (
    operation.query.definitions[0].operation === 'mutation' &&
    store.getState().authorization.role === 'transfer_claims' &&
    operation.operationName !== 'UpdateAccount'
  ) {
    setNetworkError(
      new Error('You are not allowed to perform this action'),
      operation
    );
    throw new Error('You are not allowed to perform this action');
  }

  return forward(operation);
});

const client = new ApolloClient({
  // link: new HttpLink({ uri: 'https://airrefund-crm.s.besidethepark.com/crm/graphql'}),
  // link: new HttpLink({ uri: 'http://192.168.1.137:13000/crm/graphql'}),
  link: from([readonlyMiddleware, authLink, logoutLink, errorsLink, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions,
});

injectTapEventPlugin();

const ReduxApp = () => (
  <ApolloProvider client={client}>
    <Provider store={store}>
      <App />
    </Provider>
  </ApolloProvider>
);

ReactDOM.render(<ReduxApp />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js